/**
 *
 * This file was generated with Adobe XD React Exporter
 * Exporter for Adobe XD is written by: Johannes Pichler <j.pichler@webpixels.at>
 *
 **/
import { Box, Container, Row, ColumnTow, FooterLink } from "./FooterStyles";
import React, { useEffect, useState } from "react";

import "../styles/home.scss";

const AproposComponent = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#F1F1F1",
        justifyContent: "center",
        flexDirection: "column",
        paddingLeft: size.width < 1440 ? 0 : "0",
        paddingRight: size.width < 1440 ? 0 : "0",
      }}
    >
      {size.width > 560 ? (
        <Box
          class="a-propos"
          style={{
            backgroundColor: "transparent",
            paddingLeft: "2.4rem",
            paddingRight: "2.4rem",
          }}
        >
          <Container
            className="contenerONfleek"
            style={{
              width:
                size.width === 800 ? "100%" : size.width < 800 ? "100%" : "80%",
              maxWidth: 1920,
            }}
          >
            <Row className="RowSpecTow">
              <ColumnTow
                style={{
                  marginLeft: 0,
                }}
              >
                <div>
                  <h1 class="cest-quoi-on-fleek raleway-extra-bold-eerie-black-45px">
                    C’est quoi On Fleek?
                  </h1>
                  <div class="p-web">
                    <div class="la-premire-platefor">
                      La première plateforme de réservation beauté 100% locale.
                      Prenez vos rendez-vous sans stress, même à la dernière
                      minute. Coiffure (hommes et femmes), barber, beauté
                      (mains, pieds, visages, épilations…), onglerie,
                      bien-être…profitez de vos prestations favorites en
                      seulement quelques clics.
                    </div>
                  </div>
                </div>
              </ColumnTow>
              <ColumnTow>
                <img
                  alt=""
                  class="about-on-fleek"
                  src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62341339dacf5d485e5362f3/img/about-on-fleek@1x.png"
                />
              </ColumnTow>
            </Row>
          </Container>
        </Box>
      ) : (
        <svg
          width={size.width != 428 ? size.width : 428}
          height={440}
          viewBox="0 0 428 440"
        >
          <defs>
            <style>
              {
                ".ax{fill:#f1f1f1;border}.bs{fill:url(#a);}.fg{fill:#1d1d1b;font-size:20px;font-family:Raleway-ExtraBold, Raleway;font-weight:800;}.dk{font-size:15px;font-family:Roboto-Regular, Roboto;}.e{font-family:Roboto-LightItalic, Roboto;font-weight:300;font-style:italic;}"
              }
            </style>
            <pattern
              id="a"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 600 343"
            >
              <image
                width={630}
                height={350}
                xlinkHref="Pro-Mobile-On-Fleek.png"
              />
            </pattern>
          </defs>
          <image
            width={428}
            height={195}
            xlinkHref="About-Mobile-On-Fleek.png"
            transform="translate(0 30)"
          />
          <text className="fg" transform="translate(37 274)">
            <tspan x={0} y={0} fill="black">
              {"C\u2019est quoi On Fleek?"}
            </tspan>
          </text>
          <text className="dk" transform="translate(37 296)">
            <tspan x={0} y={16}>
              {"La premi\xE8re plateforme de r\xE9servation beaut\xE9 100% "}
            </tspan>
            <tspan x={0} y={36}>
              {"locale. Prenez vos rendez-vous sans stress, m\xEAme \xE0 "}
            </tspan>
            <tspan x={0} y={56}>
              {"la derni\xE8re minute. Coiffure "}
            </tspan>
            <tspan y={56}>{"(hommes et femmes)"}</tspan>
            <tspan y={56}>{", "}</tspan>
            <tspan x={0} y={76}>
              {"barber, beaut\xE9 "}
            </tspan>
            <tspan y={76}>
              {"(mains, pieds, visages, \xE9pilations\u2026)"}
            </tspan>
            <tspan y={76}>{", "}</tspan>
            <tspan x={0} y={96}>
              {"onglerie, bien-\xEAtre\u2026profitez de vos prestations "}
            </tspan>
          </text>
        </svg>
      )}
    </div>
  );
};
export default AproposComponent;
